<template>
    <div id="chart_section">
        <!-- <h2 class="section_heading">Charts</h2> -->

        <div id="charts">
            <DoughnutChart
                v-if="rawDataCollection"
                :chart-data="rawDataCollection"
                :options="chartOptionsOne"
                class="chart"
            />

            <DoughnutChart
                v-if="filteredDataCollection"
                :chart-data="filteredDataCollection"
                :options="chartOptionsTwo"
                class="chart"
            />

            <DoughnutChart
                v-if="winLossDataCollection"
                :chart-data="winLossDataCollection"
                :options="winLossChartOptions"
                class="chart"
            />

            <div id="legend">
                <div class="key_value"><span></span>Opportunities</div>
                <div class="key_value"><span></span>Prospects</div>
                <div class="key_value"><span></span>Proposals</div>
                <div class="key_value"><span></span>Presentations</div>
                <div class="key_value"><span></span>Won</div>
                <div class="key_value"><span></span>Lost</div>
                <div class="key_value"><span></span>No Opportunity</div>
            </div>
        </div>
    </div>
</template>


<script>
import DoughnutChart from './DoughnutChart';
import { mapGetters } from 'vuex';

export default {
    components: {
        DoughnutChart
    },
    computed: {
        ...mapGetters(['boardColumns', 'winLossPostCount']),
        rawDataCollection() {
            if (this.boardColumns.length) {
                return {
                    datasets: [{
                        data: [this.boardColumns[0].total.$numberDecimal, this.boardColumns[1].total.$numberDecimal, this.boardColumns[2].total.$numberDecimal, this.boardColumns[3].total.$numberDecimal],
                        backgroundColor: [
                            '#83dd1a', 
                            '#d5d814',
                            '#fdab2f',
                            '#1ad4dd'
                        ],
                        borderColor: [
                            '#83dd1a', 
                            '#d5d814',
                            '#fdab2f',
                            '#1ad4dd'
                        ],
                    }]
                };
            } else {
                return null;
            }
        },
        filteredDataCollection() {
            if (this.boardColumns.length) {
                return {
                    datasets: [{
                        data: [
                            this.boardColumns[0].total.$numberDecimal * this.boardColumns[0].percentage.$numberDecimal, 
                            this.boardColumns[1].total.$numberDecimal * this.boardColumns[1].percentage.$numberDecimal, 
                            this.boardColumns[2].total.$numberDecimal * this.boardColumns[2].percentage.$numberDecimal, 
                            this.boardColumns[3].total.$numberDecimal * this.boardColumns[3].percentage.$numberDecimal
                        ],
                        backgroundColor: [
                            '#83dd1a', 
                            '#d5d814',
                            '#fdab2f',
                            '#1ad4dd'
                        ],
                        borderColor: [
                            '#83dd1a', 
                            '#d5d814',
                            '#fdab2f',
                            '#1ad4dd'
                        ],
                    }]
                };
            } else {
                return null;
            }
        },
        winLossDataCollection() {
            if (this.winLossPostCount.length) {
                return {
                    datasets: [{
                        data: [this.winLossPostCount[0], this.winLossPostCount[1], this.winLossPostCount[2]],
                        backgroundColor: [
                            '#0063e8', 
                            '#7c0aa5',
                            '#dd1aa1'
                        ],
                        borderColor: [
                            '#0063e8', 
                            '#7c0aa5',
                            '#dd1aa1'
                        ],
                    }]
                };
            } else {
                return null;
            }
        }
    },
    data() {
        return {
            chartOptionsOne: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false,
                    position: 'bottom',
                    labels: {
                        fontSize: 18,
                        padding: 20,
                        fontFamily: 'Arial',
                        fontColor: '#ffffff'
                    },
                },
                title: {
                    display: true,
                    text: 'Total Value Chart',
                    fontFamily: "'Encode Sans', 'sans-serif'",
                    fontSize: 26,
                    fontStyle: 700,
                    fontColor: '#6d6d6d',
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltipItem, data) {
                            var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || '';

                            return new Intl.NumberFormat('en-GB', { 
                                style: 'currency', 
                                currency: 'GBP',
                                maximumFractionDigits: value > 99.9 ? 0 : 2,
                                minimumFractionDigits: value > 99.9 ? 0 : 2,
                            }).format(value);
                        }
                    }
                },
                cutoutPercentage: 50,
            },
            chartOptionsTwo: {
                responsive: true,
                maintainAspectRatio: false,

                legend: {
                    display: false,
                    position: 'bottom',
                    labels: {
                        fontSize: 18,
                        padding: 20,
                        fontFamily: 'Arial',
                        fontColor: '#ffffff'
                    },
                },
                title: {
                    display: true,
                    text: 'Adjusted Value',
                    fontFamily: "'Encode Sans', 'sans-serif'",
                    fontSize: 26,
                    fontStyle: 700,
                    fontColor: '#6d6d6d',
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltipItem, data) {
                            var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || '';

                            return new Intl.NumberFormat('en-GB', { 
                                style: 'currency', 
                                currency: 'GBP',
                                maximumFractionDigits: value > 99.9 ? 0 : 2,
                                minimumFractionDigits: value > 99.9 ? 0 : 2,
                            }).format(value);
                        }
                    }
                },
                cutoutPercentage: 50,
            },
            winLossChartOptions: {
                responsive: true,
                maintainAspectRatio: false,

                legend: {
                    display: false,
                    position: 'bottom',
                    labels: {
                        fontSize: 18,
                        padding: 20,
                        fontFamily: 'Arial',
                        fontColor: '#ffffff'
                    },
                },
                title: {
                    display: true,
                    text: 'Won vs Loss',
                    fontFamily: "'Encode Sans', 'sans-serif'",
                    fontSize: 26,
                    fontStyle: 700,
                    fontColor: '#6d6d6d',
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltipItem, data) {
                            return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || '';
                        }
                    }
                },
                cutoutPercentage: 50,
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .section_heading{
        font-size: 3rem;
        font-weight: 700;
        line-height: 1.3;
        color: $primary-three;
    }

    #chart_section{
        margin-top: 4rem;
        width: 100%;
        // padding: 5rem;
        // background-color: #eaeaea;
        // border-top: 0.1rem solid $primary-two;
        // border-bottom: 0.1rem solid $primary-two;

        #charts{
            display: flex;
            flex-wrap: wrap;
            // margin-top: 4rem;
            width: 100%;
            // background-color: #fff;
            // background: linear-gradient(to bottom,rgba(255,255,255,.5) 1%,rgba(70,200,197,.5) 100%);
            // height: 28rem;
            // padding: 4rem;

            .chart{
                width: 33.33333%;
            }

            #legend{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                width: 100%;
                margin-top: 6rem;

                .key_value{
                    display: flex;
                    align-items: center;
                    font-size: 2rem;
                    font-weight: 500;
                    color: $primary-three;

                    span{
                        width: 5rem;
                        height:2rem;
                        display: inline-block;
                        margin-right: 1rem;
                    }

                    &:nth-of-type(1) {
                        span{
                            background-color: #83dd1a;
                        }
                    }

                    &:nth-of-type(2) {
                        span{
                            background-color: #d5d814;
                        }
                    }

                    &:nth-of-type(3) {
                        span{
                            background-color: #fdab2f;
                        }
                    }

                    &:nth-of-type(4) {
                        span{
                            background-color: #1ad4dd;
                        }
                    }

                    &:nth-of-type(5) {
                        span{
                            background-color: #0063e8;
                        }
                    }

                    &:nth-of-type(6) {
                        span{
                            background-color: #7c0aa5;
                        }
                    }

                    &:nth-of-type(7) {
                        span{
                            background-color: #dd1aa1;
                        }
                    }
                }
            }
        }
    }
</style>